// extracted by mini-css-extract-plugin
export default {"tooltip":"qT-z","arrow":"rT-z"};